import { useState, useCallback } from "react";

/**
 * Custom hook for managing user selection state
 * Used in Users page and InviteSection for selecting multiple users
 */
export function useUserSelection() {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isSelectionMode, setIsSelectionMode] = useState(false);

  const handleToggleSelectionMode = useCallback(() => {
    setIsSelectionMode((prev) => {
      if (prev) {
        // Clear selection when exiting selection mode
        setSelectedUsers([]);
      }
      return !prev;
    });
  }, []);

  const handleToggleUserSelection = useCallback((user) => {
    setSelectedUsers((prev) =>
      prev.some((u) => u.id === user.id)
        ? prev.filter((u) => u.id !== user.id)
        : [...prev, user]
    );
  }, []);

  const isUserSelected = useCallback(
    (userId) => {
      return selectedUsers.some((u) => u.id === userId);
    },
    [selectedUsers]
  );

  const clearSelection = useCallback(() => {
    setSelectedUsers([]);
    setIsSelectionMode(false);
  }, []);

  const selectAll = useCallback((users) => {
    setSelectedUsers(users);
  }, []);

  return {
    selectedUsers,
    isSelectionMode,
    handleToggleSelectionMode,
    handleToggleUserSelection,
    isUserSelected,
    clearSelection,
    selectAll,
    setIsSelectionMode,
  };
}
